/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetGrowSummaryRequest} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'
import {GetGrowSummaryResponse} from '@cash-web/protos/squareup/cash/cashliteorchestrator/api/v1beta1/orchestrator.pb'


export const getGrowSummary = (request: GetGrowSummaryRequest, options?: CashRequestOptions) => post<GetGrowSummaryRequest, GetGrowSummaryResponse>("/2.0/cash/get-grow-summary", request, {...options, rejectOnError: true })